import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    channels: [],
    loading: false,
    errorMsg: '',
    errors: {}
};

const channelSlice = createSlice({
    name: 'channels',
    initialState,
    reducers: {
        setChannel: (state, action) => {
            state.channels = action.payload;
        },
        getErrors: (state, action) => {
            state.errorMsg = action.payload.errorMsg;
            state.errors = action.payload.errors;
        },
        clearErrors: (state) => {
            state.errorMsg = '';
            state.errors = '';
        },
        loading: (state, action) => {
            state.loading = action.payload;
        },
    },
});

export const { loading, setChannel, clearErrors, getErrors } = channelSlice.actions;
export default channelSlice.reducer;
